import { ICountry, IState } from "pages/dashboard/people/people/typings"
import { useQuery } from "@tanstack/react-query"
import { COMMON_ENDPOINTS, commonService } from "services/commonService"

export const useGetCountries = () => {
  const {
    data: countriesRes,
    isLoading,
    isFetching,
    refetch,
  } = useQuery<IBaseRes<ICountry[]>>({
    queryKey: [COMMON_ENDPOINTS.GET_COUNTRIES],
    queryFn: () => commonService.getCountries(),
  })

  const countries = countriesRes?.data || []

  return { countries, isLoading, isFetching, refetch }
}
export const useGetStates = ({
  countryCode = "NG",
}: {
  countryCode: string
}) => {
  const {
    data: statesRes,
    isLoading,
    isFetching,
    refetch,
  } = useQuery<IBaseRes<IState[]>>({
    queryKey: [COMMON_ENDPOINTS.GET_STATES_BY_COUNTRY, countryCode],
    queryFn: () => commonService.getStatesByCountry(countryCode),
    enabled: !!countryCode,
  })

  const states = statesRes?.data || []

  return { states, isLoading, isFetching, refetch }
}
